import React, { useEffect, useState } from 'react';
import { animated, useTrail } from 'react-spring';

import { APIHandler, DataHandler, ServicesCard } from 'C4';

const getServices = async (set) => set(await APIHandler.getServices(DataHandler.matchAppIdSync()));

const animation = {
  from: { opacity: 0, transform: 'translateY(10%)' },
  to: { opacity: 1, transform: 'translateY(0%)' },
};

const Services = () => {
  const [services, setServices] = useState([]);
  const [trail, set] = useTrail(services.length, () => animation.from);

  useEffect(() => {
    if (services.length === 0) {
      getServices((newServices) => {
        setServices(newServices);
        set(animation.to);
      });
    }
  }, [services, set]);

  return (
    <div className="fastfacts__Grid">
      {trail.map((style, i) => {
        const { type, itemID } = services[i];

        return (
          type && (
            <animated.div key={itemID} className="fastfactsCard__Animated" style={style}>
              <ServicesCard index={i} {...services[i]} />
            </animated.div>
          )
        );
      })}
    </div>
  );
};

export default Services;
